import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { IndicatorScoreListing } from './components/IndicatorScoreListing';
import { NewIndicatorScoreDrawer } from './components/NewIndicatorScoreDrawer';
export type ManageIndicatorScoresProps = {
  organizationId: string;
};

export const ManageIndicatorScores = ({
  organizationId,
}: ManageIndicatorScoresProps) => {
  const [showDrawer, setShowDrawer] = useState(false);

  const org = useStore($org);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/indicatorscore`
        : '/organizations',
    },
    {
      label: 'Indicator Scores',
      href: `/organization/${org?.id}/indicatorscore`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Indicator Scores</h2>
          <p className="text-muted-foreground">
            {`List of indicator scores for ${org?.name}.`}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Button onClick={() => setShowDrawer(true)}>
            <PlusIcon className="mr-2 h-4 w-4" /> Add New
          </Button>
        </div>
      </div>

      {/* Portfolio list */}
      <div className="mt-4 max-w-4xl">
        <IndicatorScoreListing/>
      </div>

      {/* Create New Indicator Score Drawer */}
      <NewIndicatorScoreDrawer    
        open={showDrawer}
        setOpen={setShowDrawer}
      />  
    </div>
  );
};